import { Steart } from 'app/models/core/steart.model';
import { ZeWidgetDef, ZeWidgetItem } from './vbl.ze.widgets';

export const VasZeWidgets: ZeWidgetDef[] = [
	new ZeWidgetDef({
		title: 'Leben und Fonds inklusive FRV-Zusatzbewertung',
		key: 'ZE_Rente_Leben_undFonds_VAS',
		stearts: [Steart.VAS],
		items: [
			new ZeWidgetItem({
				text: <strong>Summe der Zielerfüllungen im individuellen Arbeitsgebiet 190%</strong>,
				posId: 2225045,
				einheit: '%',
			}),
			new ZeWidgetItem({
				title: 'Mindestens in Leben 90%',
				subtitle: 'Bewertung ohne ZE mit 1,5-facher Wertung PrivateFinance-/PrivateMarketsPolice ',
				text: <></>,
				posId: 2225041,
			}),
			new ZeWidgetItem({
				title: 'Mindestens in Fonds inklusive FRV-Zusatzbewertung 90%',
				subtitle: 'Bewertung',
				text: <></>,
				posId: 2225043,
			}),
		],
	}),
	new ZeWidgetDef({
		title: 'oder Leben Neustück',
		key: 'ZE_Rente_Leben_VAS',
		stearts: [Steart.VAS],
		items: [
			new ZeWidgetItem({
				text: <strong>Anzahl GV/HV mit Erfüllung der Position VSP Leben Neustück im Geschäftsplan 30%</strong>,
				posId: 2270801,
			}),
		],
	}),
];
